function EmptyState({ className = '', message }: { className?: string; message?: string }) {
  return (
    <div className={`flex justify-center pt-[11.25rem] ${className}`}>
      <div className="flex h-[8.188rem] min-w-[11rem] flex-col items-center justify-center rounded-[0.625rem] py-1 px-3 bg-gray-50">
        <i className="icon-check-circle text-[3.438rem] leading-none text-[#d2e0e7]" />
        <p className="mt-[0.563rem] text-[0.985rem] font-normal leading-none text-gray-500">
          {message || 'No Data'}
        </p>
      </div>
    </div>
  );
}
export default EmptyState;
